<template>
  <div class="w-full sm:w-4/5 md:3/4 2xl:w-1/2 pb-8">
    <div class="hidden md:block text-center my-10">
      <h1>{{ $t('page.login.sentence.welcome') }}</h1>
    </div>

    <div v-if="isUsingCustomToken" class="text-center mt-60">
      <div v-if="isCustomTokenFailed">
        {{ $t('sentence.default_error') }}
      </div>
      <div v-else><i class="fas fa-spin fa-spinner fa-2x"></i></div>
    </div>
    <div v-else>
      <form @submit.prevent="login" class="my-12" v-if="!isEmailSended">
        <div class="space-y-8">
          <base-input
            :label="$t('form.label.email')"
            name="email"
            type="email"
            v-model="v$.email.$model"
            autocomplete="username"
            left-icon="far fa-envelope"
            :error-message="emailErrorMessage"
          />
        </div>

        <div class="w-full my-6 md:my-12">
          <button
            :disabled="isSubmitDisabled"
            type="submit"
            class="btn btn-primary btn-lg w-full"
          >
            {{ $t('page.login.action.enter') }}
          </button>
        </div>
      </form>
      <div v-else>
        Enviamos uma solicitação de login para o seu email. Verifique sua caixa de entrada.
      </div>
    </div>
  </div>
  <div class="absolute top-0 right-0 m-3">
    <language-select clean />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, reactive, toRaw, onBeforeMount, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useVuelidate } from '@vuelidate/core'
import { email, required, helpers } from '@vuelidate/validators'
import { useAuth } from '@/composables/firebase/useAuth'
// import SocialLoginButton from '../components/auth/SocialLoginButton.vue'
import BaseInput from '@/components/base/BaseInput.vue'
import LanguageSelect from '@/components/settings/languageSelect.vue'
import { useI18n } from 'vue-i18n'
import { useAxios } from '@/composables/useAxios'

export default defineComponent({
  components: {
    BaseInput,
    LanguageSelect
  },
  setup () {
    const isEmailSended = ref(false)

    const { t } = useI18n()

    const {
      loginWithLinkToEmail,
      loginWithCustomToken
    } = useAuth()

    const isUsingCustomToken = ref(false)
    const isCustomTokenFailed = ref(false)

    const form = reactive({
      email: '',
    })

    const rules = {
      email: {
        required: helpers.withMessage(t('validations.required'), required),
        email: helpers.withMessage(t('validations.email'), email),
      }
    }

    const v$ = useVuelidate(rules, form)

    const isSubmitDisabled = computed(() => {
      return v$.value.$invalid
    })

    const emailErrorMessage = computed(() => v$.value.email.$errors[0]?.$message)

    const login = async () => {
      if (!isSubmitDisabled.value) {
        isEmailSended.value = await loginWithLinkToEmail(toRaw(form))
      }
    }

    async function attemptLoginWithCustomToken (token: string, otp: string) {
      isUsingCustomToken.value = true

      const { httpFunctions } = await useAxios()

      try {
        const { data } = await httpFunctions.get('/api/auth', {
          params: { token, otp }
        })

        await loginWithCustomToken(data.token)
      } catch (error) {
        isCustomTokenFailed.value = true
        console.error(error)
      }
    }

    onBeforeMount(async () => {
      const router = useRouter()
      const { token, otp } = router.currentRoute.value.query

      if (typeof token === 'string' && typeof otp === 'string') {
        await attemptLoginWithCustomToken(token, otp)
      }
    })

    return {
      isEmailSended,
      emailErrorMessage,
      form,
      login,
      isSubmitDisabled,
      isUsingCustomToken,
      isCustomTokenFailed,
      v$,
    }
  }
})
</script>
